import React, { useEffect, memo } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { Icon } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { Row } from 'components/layout';
import { useCommon } from 'hooks/useCommon';
import { useAuth } from 'lib/providers/AuthProvider';
import { PAGE_ROUTES } from 'lib/page-routes';
import { CommitteeMembers } from '../CommitteeMembers/CommitteeMembers.component';

import styles from './CommitteeDashboard.module.scss';

export const CommitteeDashboard: React.FC = memo(() => {
  const [t] = useTranslation('committee');
  const router = useRouter();
  const { isManager } = useAuth();
  const { onShare } = useCommon();

  useEffect(() => {
    if (!isManager) {
      router.replace(PAGE_ROUTES.SIGN_IN_SOCIETY);
    }
  }, [isManager]);

  return (
    <>
      <section
        className={styles.CommitteeDashboard}
        data-testid="CommitteeDashboard"
      >
        <Row
          align="center"
          columnGap={4}
          className={styles.redirect}
          onClick={() => router.push(PAGE_ROUTES.DASHBOARD)}
        >
          <Icon iconName="chevron-left" size="large" />
          {t('header.back-to-home')}
        </Row>
        <div className={styles.header}>
          <p className={styles.title}>{t('header.title')}</p>
          <ButtonV3
            onClick={() =>
              onShare(
                'Manager Signup',
                `${window.location.origin}${PAGE_ROUTES.MANAGER_SIGN_UP}`,
                {
                  title: `${t('invite-link-copied-notification.title')}`,
                  message: `${t('invite-link-copied-notification.message')}`,
                }
              )
            }
          >
            {t('header.actions.invite')}
          </ButtonV3>
        </div>
        <CommitteeMembers />
      </section>
    </>
  );
});

CommitteeDashboard.displayName = 'CommitteeDashboard';
